/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { WirelessHealthDetail } from "../../models/wireless-health-detail";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetWirelessHealthDetail$Params {
  subscription_id: string;
}

export function getWirelessHealthDetail(
  http: HttpClient,
  rootUrl: string,
  params: GetWirelessHealthDetail$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<WirelessHealthDetail>> {
  const rb = new RequestBuilder(rootUrl, getWirelessHealthDetail.PATH, "get");
  if (params) {
    rb.path("subscription_id", params.subscription_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WirelessHealthDetail>;
    }),
  );
}

getWirelessHealthDetail.PATH = "/dashboard/health/wireless/{subscription_id}/detail";
